import { useCallback, useRef } from 'react';

/** Keep picker and upload callbacks fenced when access changes while mounted. */
export function useUploadGuard(disabled: boolean) {
  const disabledRef = useRef(disabled);
  disabledRef.current = disabled;

  const openPicker = useCallback((input: HTMLInputElement | null | undefined) => {
    if (!disabledRef.current && input && !input.disabled) input.click();
  }, []);

  const blockEvent = useCallback((event: { preventDefault: () => void; stopPropagation: () => void }) => {
    if (!disabledRef.current) return false;
    event.preventDefault();
    event.stopPropagation();
    return true;
  }, []);

  // Saved-document links and other non-upload actions may share a tile.
  // Their own buttons retain their permissions; only tile activation is consumed.
  const blockActivation = useCallback((event: {
    target: EventTarget; currentTarget: EventTarget; key?: string;
    preventDefault: () => void; stopPropagation: () => void;
  }) => {
    if (event.key && event.key !== 'Enter' && event.key !== ' ') return false;
    if (event.target instanceof Element && event.target !== event.currentTarget
      && event.target.closest('a[href], button, [role="link"]')) return false;
    return blockEvent(event);
  }, [blockEvent]);

  return { disabledRef, openPicker, blockEvent, blockActivation };
}
